<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div :class="['IM_1_' + this.id]">
    <div class="container">
      <div class="row justify-content-end">
        <div class="col col-12 col-md-9">
          <h1 class="mt-10 mb-5">
            T'est-il déjà arrivé de rêvasser, de laisser filer tes pensées et pour quelques instants, de perdre contact
            avec la réalité ?
          </h1>
          <p class="mt-2 mb-5">
            Imagine un autre monde, un monde que tu ne pourrais explorer que dans cet état d’esprit… Un monde
            immatériel, où ta conscience serait reliée à celles de centaines d’autres personnes… Et si ce monde existait
            déjà sans que tu le saches&nbsp;?
            <br />
            <br />Avant de te lancer dans l’aventure, munis toi d’un peu de papier, d’un crayon et si tu en as, branche
            tes écouteurs. Enfin, assure toi d’avoir un peu de temps devant toi (environ une heure), tu ne pourras pas
            sauvegarder&nbsp;!
          </p>
          <div v-on:click="emitMusic('play', 2)">
            <router-link class="next" :to="'/immersion01/' + (this.id + 1)">Entrer dans la troposhère ></router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="ballon">
      <img src="https://cdn.exploreve.fr/content/ballons/ballon_rouge.svg" alt />
    </div>
    <div class="nuage n01"></div>
    <div class="nuage n02"></div>
    <div class="nuage n03"></div>
    <div class="nuage n04"></div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "IM_1_0",
  data: function () {
    return {
      id: 0
    };
  },
  methods: {
    emitMusic: function (action, id) {
      this.$emit("audio", { action: action, id: id });
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
.container {
  text-align: left;
}

.title {
  margin-top: 100px;
}

p {
  font-size: 24px;
}

a.next {
  display: block;
  font-size: 24px;
  color: $dark;
  text-align: right;
  text-decoration: underline;
  cursor: pointer;
  margin-bottom: 45px;
  &:hover {
    text-decoration: underline;
  }
}

.ballon {
  position: absolute;
  top: -5%;
  left: 5%;
  img {
    height: 100vh;
  }
  z-index: 5;
}

.nuage {
  position: absolute;
  background-color: $light;
  opacity: 0.7;
}

.n01 {
  top: 50%;
  left: -5%;
  width: 350px;
  height: 40px;
  border-radius: 20px;
  z-index: 10;
}

.n02 {
  top: 80%;
  left: -5%;
  width: 600px;
  height: 120px;
  border-radius: 60px;
  z-index: 0;
}

.n03 {
  top: 15%;
  left: 20%;
  width: 400px;
  height: 100px;
  border-radius: 50px;
  z-index: 10;
}

.n04 {
  top: 20%;
  right: 2%;
  width: 300px;
  height: 40px;
  border-radius: 20px;
  z-index: 5;
}
</style>
